module.exports = __webpack_public_path__ + "img/minus.01a23882.svg";